/** Дата в формате YYYY-MM-DD для API (фильтры created_after/created_before). */
export const formatDateOnlyForAPI = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

/** Дата и время в формате YYYY-MM-DD HH:MM:SS для API. */
export const formatDateForAPI = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export const formatDateForInput = (date: Date | null): string => {
  if (!date) {
    return ''
  }
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  return `${day}.${month}.${year}`
}

export const formatTimeForInput = (date: Date | null): string => {
  if (!date) {
    return ''
  }
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${hours}:${minutes}`
}

export const parseDateFromInput = (dateString: string): Date | null => {
  if (!dateString) {
    return null
  }
  const [day, month, year] = dateString.split('.').map(Number)
  if (!day || !month || !year) {
    return null
  }

  return new Date(year, month - 1, day)
}

export const parseTimeFromInput = (
  timeString: string,
): { hours: number; minutes: number } | null => {
  if (!timeString) {
    return null
  }
  const [hours, minutes] = timeString.split(':').map(Number)
  if (hours === undefined || minutes === undefined) {
    return null
  }

  return { hours, minutes }
}

export const setStartOfDay = (date: Date): Date => {
  const newDate = new Date(date)

  newDate.setHours(0, 0, 0, 0)

  return newDate
}

export const setEndOfDay = (date: Date): Date => {
  const newDate = new Date(date)

  newDate.setHours(23, 59, 59, 999)

  return newDate
}

/** Время в формате HH:MM:SS для API. */
export const formatTimeForAPI = (date: Date): string => {
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${hours}:${minutes}:${seconds}`
}

/** Парсит время из HH:MM:SS или HH:MM в Date (текущая дата + время). */
export const parseTimeFromAPI = (timeString: string): Date | null => {
  if (!timeString) {
    return null
  }
  const parts = timeString.split(':')
  if (parts.length < 2) {
    return null
  }
  const hours = Number(parts[0])
  const minutes = Number(parts[1])
  if (isNaN(hours) || isNaN(minutes)) {
    return null
  }

  const date = new Date()

  date.setHours(hours, minutes, parts[2] ? Number(parts[2]) : 0, 0)

  return date
}

/** Парсит дату/время из ISO, YYYY-MM-DD HH:MM[:SS] и DD.MM.YYYY HH:MM[:SS]. */
export const parseDateTimeValue = (value: unknown): Date | null => {
  if (!value) {
    return null
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value !== 'string') {
    return null
  }

  const str = value.trim()
  if (!str) {
    return null
  }

  const ruMatch = str.match(
    /^(\d{2})\.(\d{2})\.(\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/,
  )
  if (ruMatch) {
    const day = Number(ruMatch[1])
    const month = Number(ruMatch[2])
    const year = Number(ruMatch[3])
    const hours = Number(ruMatch[4] ?? '0')
    const minutes = Number(ruMatch[5] ?? '0')
    const seconds = Number(ruMatch[6] ?? '0')
    const date = new Date(year, month - 1, day, hours, minutes, seconds)

    return Number.isNaN(date.getTime()) ? null : date
  }

  const isoLike = /^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2})?)?$/.test(str)
    ? str.replace(' ', 'T')
    : str
  const date = new Date(isoLike)

  return Number.isNaN(date.getTime()) ? null : date
}
